// extracted by mini-css-extract-plugin
export default {"wrap":"EventDetails_wrap__GoYZ6","title":"EventDetails_title__9YfwK","description":"EventDetails_description__hlNl4"};